/**
 * Copyright IBM Corp. 2022, 2026
 */

import { MDSButton } from '@hashicorp/mds-react/components'
import s from './BlogCtaButton.module.css'

export default function BlogCTAButton({ url, text }) {
	return (
		<section className={s.ctaButtonContainer}>
			<MDSButton
				title={text}
				url={url}
				theme={{ brand: 'hashicorp', variant: 'primary' }}
			/>
		</section>
	)
}
